import { useGetBlackFriday } from '../../../hooks/marketing/useGetBlackFriday'
import HolidayBanner from './HolidayBanner'
import SnowBackground from '../../../public/static/banner/spring-sale.png'

export default function BlackFridayBannerV2() {
  const { data } = useGetBlackFriday()

  if (data?.countDown.values.seconds && data?.countDown.values.seconds <= 0) {
    return null
  }

  return (
    <div className='flex flex-col w-full'>
      <HolidayBanner
        countDown={data?.countDown.values.seconds ?? 0}
        background={SnowBackground}
        backgroundWidth={' w-[55%] '}
        darkTheme={true}
        rightBackgroundColor={'bg-[#8F15CD] '}
        // timerBackgroundColor={'bg-black'}
        // timerTextColor={'text-white'}
      />
      {/*<div className='relative w-full h-10'>*/}
      {/*  <Image*/}
      {/*    src={SnowBackground}*/}
      {/*    alt={'Snow'}*/}
      {/*    fill={true}*/}
      {/*    className={'object-cover'}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  )
}
